import request from '@/utils/request'

/**
 * 付款单子菜单服务
 * 用于动态生成付款单的子菜单项
 */
export class PaymentChildrenMenu {
  /**
   * 获取可用于付款单的费用类型
   */
  static async getPaymentCostTypes() {
    try {
      const response = await request.get('/api/costType/all')
      if (response.success) {
        // 过滤出可用于付款单的费用类型
        return response.data.filter(item => item.forPayment === true && item.disabled === false)
      }
      return []
    } catch (error) {
      console.error('获取费用类型失败:', error)
      return []
    }
  }

  /**
   * 生成付款单子菜单
   */
  static async generatePaymentSubMenus() {
    const costTypes = await this.getPaymentCostTypes()
    
    return costTypes.map(costType => ({
      path: `${costType.id}`,
      component: () => import('@/views/Finance/PaymentCostType'),
      name: `FinancePaymentCostType${costType.id}`,
      meta: { 
        title: costType.name, 
        affix: false,
        costTypeId: costType.id,
        costTypeName: costType.name
      },
      hidden: false
    }))
  }

  /**
   * 动态添加菜单到路由
   * @param {Array} routes - 路由数组
   * @param {Array} menus - 菜单列表
   * @returns {Array} - 返回动态菜单路径数组
   */
  static async addDynamicMenus(routes, menus) {
    try {
      const subMenus = await this.generatePaymentSubMenus()
      
      // 找到财务模块的路由
      const financeRoute = routes.find(route => route.path === '/finance')
      
      if (financeRoute && financeRoute.children) {
        // 找到付款单菜单（通过 path 匹配，因为父路由没有 name）
        const paymentRoute = financeRoute.children.find(child => child.path === '/finance/payment/cost-type')

        if (paymentRoute) {
          // 确保 paymentRoute 有 children 数组
          if (!paymentRoute.children) {
            paymentRoute.children = []
          }

          // 移除已存在的动态菜单
          paymentRoute.children = paymentRoute.children.filter(child => 
            !child.name || !child.name.startsWith('FinancePayment')
          )
          
          // 先添加具体路径的费用类型子菜单（优先匹配）
          paymentRoute.children.push(...subMenus)
          
          // 返回动态菜单的完整路径数组（包含总览和费用类型子菜单）
          const paths = [
            ...subMenus.map(menu => `/finance/payment/cost-type/${menu.path}`)
          ]
          return paths
        }
      }
    } catch (error) {
      console.error('添加动态菜单失败:', error)
    }
    return []
  }
}

export default PaymentChildrenMenu

